<template>
	<div>
		<div class="mb-12" v-if="giftcard">
			<h3>Gratulerer!</h3>
			<h4>Ditt Fixit.no-gavekort er nå aktivert.</h4>
			<h5>Beløp: kr {{ giftcard.RestAmount }}.</h5>
			<h5>Utløpsdato: {{ giftcard.ExpirationDate | dateFormatString }}</h5>
			<p class="mt-3">
				Gavekortet kan benyttes som betaling i alle salonger du finner på fixit.no, og du bestiller enkelt time i din favorittsalong. Oversikt over aktiverte gavekort finner du på
				<router-link to="/minside/fixit-gavekort">min side</router-link> på fixit.no
			</p>
		</div>
		<div class="text-center text-sm-left">
			<v-btn color="primary" to="/">Bestill time</v-btn>
			<v-btn class="ml-2 mt-sm-0 mt-3" color="grey" :to="{ name: 'mypage/fixit-giftcard' }">Se mine gavekort</v-btn>
		</div>
	</div>
</template>

<script>
export default {
	name: 'activate-giftcard-complete',
	components: {},
	props: {
		giftcard: null,
		value: null // Current step
	},
	data() {
		return {};
	},
	created() {},
	mounted() {},
	computed: {},
	methods: {},
	watch: {}
};
</script>

<style lang="scss" scoped></style>
